import { jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        d: "M14 3.072a8 8 0 0 1 2.617 11.424l4.944 4.943a1.5 1.5 0 0 1-2.008 2.225l-.114-.103-4.943-4.944a8 8 0 0 1-12.49-6.332L2 10l.005-.285A8 8 0 0 1 14 3.072"
      }
    )
  }
);
export {
  e as default
};
